import { merge } from "lodash";
import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import Document from "../../../../common/document/document.component.jsx";
import Icon from "../../../../common/icon/icon.component.jsx";
import SectionWrapper from "../../sectionwrapper.component.jsx";
class FileGalleryContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    getFilesFromCustomFields() {
        const customFieldRelations = this.state.variables?.project?.customFieldRelations
        if (!customFieldRelations) {
            return []
        }

        const sectionContentCustomFieldDefinitionIds = this.state.section.attributes.content.customFieldDefinitionIds
        if (!sectionContentCustomFieldDefinitionIds) {
            return []
        }
        const projectCustomFieldDefinitionIds = Object.keys(customFieldRelations)

        let customFieldFiles = []

        for (let sectionContentCustomFieldDefinitionId of sectionContentCustomFieldDefinitionIds) {
            if (!projectCustomFieldDefinitionIds.includes(sectionContentCustomFieldDefinitionId)) {
                continue
            }

            const customFieldFileRelation = customFieldRelations[sectionContentCustomFieldDefinitionId]
            if (!customFieldFileRelation) {
                continue
            }

            for (let file of customFieldFileRelation) {
                switch (file.type) {
                    case "images":
                        customFieldFiles.push(
                            merge(file, {
                                attributes: {
                                    name: file.attributes.originalFileName,
                                    filePublicUrl: file.attributes.originalFilePublicUrl,
                                    extension: file.attributes.extension,
                                }
                            })
                        )
                        break;
                    case "files":
                        customFieldFiles.push(
                            merge(file, {
                                attributes: {
                                    name: file.attributes.originalFileName,
                                    filePublicUrl: file.attributes.originalFilePublicUrl,
                                    extension: file.attributes.extension,
                                }
                            })
                        )
                        break;
                }
            }
        }

        return customFieldFiles
    }

    render() {
        if (!this.state.section) {
            return <div />
        }
        const hide = this.state.editable ? '' : 'd-none'

        const files = this.state.section.attributes.content.files.concat(this.getFilesFromCustomFields())

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className="col-12 py-2">
                    <div className="row">
                        {files.length > 0 ?
                            files.map((doc, i) => {
                                return <div key={i} className="col-xs-6 col-sm-6 col-md-3 col-lg-2">
                                    <Document
                                        name={doc.attributes.name}
                                        link={doc.attributes.filePublicUrl}
                                        extension={doc.attributes.extension}
                                        size={'large'}
                                    />
                                </div>
                            }) : <div className={'col-12 ' + hide}>
                                <p className={"section-empty-message m-0 text-left"}>
                                    {this.state.section.attributes.internalName}
                                </p>
                                <p className={"section-empty-message"}>
                                    <Icon value={"file-pdf"} />
                                    <small className={"ml-2"}>
                                        <FormattedMessage
                                            id="templates.sections.file_gallery.empty_message"
                                            defaultMessage="There is no file in this section"
                                        />
                                    </small>
                                </p>
                            </div>}
                    </div>
                </div>
            </SectionWrapper>
        );
    }
}

export default FileGalleryContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/file-gallery/section.component.jsx